// src/App.js
import React, { useState, useEffect, useRef } from 'react';
import io from 'socket.io-client';
import { getMessages, sendMessagesServices } from '../../services/api';
import { RoutesPaths } from '../../Router/constant';
import { useLocation, useNavigate, useParams } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import { getAllChatList, updateChatLastMessage } from '../../actions/chatv2';
import { getProfileAction } from '../../actions/user';
import ChatWindowStatic from './components/ChatWindowStatic';
import { addPublicUserAction, logoutInvalidToken, validUserAction } from '../../actions/auth';
import ChatSideBar from './components/ChatSideBar';
import { PUSH_NOTIFICATION_MODULE } from '../../constants';
import { useForm } from 'react-hook-form';
import { getProfileByTrackingIdAction, getSingleCampaignDetailAction } from '../../actions/peopleai';
import ImageViewer from 'react-simple-image-viewer';
import { chatMediaGetAction, chatMediaPreviewerAction } from '../../actions/chat';
import { trackAnalyticsEvent } from '../../firebase';
import AuthService from '../../services/auth.service';

export default function MessageDetailStatic() {
  const params = new URLSearchParams(window.location.search);
  const currentUserId = params.get('room');
  const { id, campaignId } = useParams();
  const ispublic = id;
  const ispublicCampain = campaignId;

  const { singleCampaignDetail } = useSelector(state => state.peopleai)
  const {
    register,
    handleSubmit,
    reset,
    setValue,
    watch,
    formState: { errors },
  } = useForm({});
  const navigate = useNavigate()
  const location = useLocation()
  const dispatch = useDispatch()
  const socketRef = useRef(null);
  const activationChatPageViewTrackedRef = useRef("");
  const [socket, setSocket] = useState(null);
  const [selected, setSelected] = useState(null); // { chat, lastMessage }
  const [messages, setMessages] = useState([]);   // active chat messages
  const [isMessageLoading, setIsMessageLoading] = useState(true);
  const { user } = useSelector(state => state?.user);
  const { isLoggedIn } = useSelector(state => state?.auth);
  const { publicProfile } = useSelector(state => state?.peopleai);
  const isloadingRef = useRef(false)
  const [step, setStep] = useState("askInvestor");
  const [isObjective, setIsObjective] = useState(false);
  const [askNameEmail, setAskNameEmail] = useState(false);
  const [describeObjective, setDescribeObjective] = useState(false);
  const [investorDescribe, setInvestorDescribe] = useState(false);
  const [advisorTimer, setAdvisorTimer] = useState(false);
  const [started, setStarted] = useState(false);
  const [secondsLeft, setSecondsLeft] = useState(120);
  const [hasExistingChat, setHasExistingChat] = useState(false);
  const { currentImage, isViewerOpen, chatMediaFileName } = useSelector((state) => state.chat);

  const [emailError, setEmailError] = useState(false);
  const [submitLoader, setSubmitLoader] = useState(false);
  const [inviterDetails, setInviterDetails] = useState(null);

  const isAdvisorUser = publicProfile?.company?.isDefault

  const trackActivationChatPageView = (roomId = currentUserId) => {
    if (ispublicCampain) return;

    const pageUrl = ispublic
      ? RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT.replace(":id", ispublic)
      : RoutesPaths.MESSAGE_DETAIL_PUBLIC;
    const roomValue = roomId || "";
    const trackKey = `${pageUrl}:${roomValue}`;

    if (activationChatPageViewTrackedRef.current === trackKey) return;
    activationChatPageViewTrackedRef.current = trackKey;

    trackAnalyticsEvent("activation_chat_page_view", {
      page_url: pageUrl,
      room_id: roomValue,
      public_user_id: ispublic || "",
      pathname: location.pathname,
    });
  }

  const getPublicMessageDetailUrl = (roomId) => {
    let url = RoutesPaths.MESSAGE_DETAIL_PUBLIC;

    if (ispublicCampain) {
      url = RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT_CAMPAIGN.replace(":id", ispublic).replace(":campaignId", ispublicCampain);
    } else if (ispublic) {
      url = RoutesPaths.MESSAGE_DETAIL_PUBLIC_CHAT.replace(":id", ispublic);
    }

    return roomId ? `${url}?room=${encodeURIComponent(roomId)}` : url;
  }

  useEffect(() => {
    const root = document.documentElement;

    if (isAdvisorUser) {
      root.style.setProperty("--primary-color", "#494DA2");
      root.style.setProperty("--third-color", "rgba(73, 77, 162, 0.4)");
      root.style.setProperty("--linear-primary", "linear-gradient(90deg, #0d1b26 0%, #494DA2 100%)");
      root.style.setProperty("--low-opacity-primary", "rgba(73, 77, 162, 0.05)");
      root.style.setProperty('--step-card-background', 'rgba(73, 77, 162, 0.10)');
    } else {
      root.style.setProperty("--primary-color", "#2978b5");
      root.style.setProperty("--third-color", "#91bdde");
      root.style.setProperty("--linear-primary:", "linear-gradient(90deg, #0d1b26 0%, #30638c 100%)");
      root.style.setProperty("--low-opacity-primary", "rgba(41, 120, 181, 0.05)");
      root.style.setProperty('--step-card-background', 'rgba(41, 120, 181, 0.05)');
    }
  }, [isAdvisorUser]);


  useEffect(() => {
    if (!isloadingRef?.current) {
      if (isLoggedIn) {
        dispatch(logoutInvalidToken())
        isloadingRef.current = true
      }
    }
    getAdvisorId()
  }, [dispatch, ispublic])

  useEffect(() => {
    const storedInviter = sessionStorage.getItem("publicChatInviter");

    if (!storedInviter) {
      setInviterDetails(null);
      return;
    }

    try {
      const parsedInviter = JSON.parse(storedInviter);
      if (parsedInviter?.inviter_id === ispublic) {
        setInviterDetails(parsedInviter);
      } else {
        setInviterDetails(null);
      }
    } catch (error) {
      setInviterDetails(null);
    }
  }, [ispublic]);

  const getAdvisorId = async () => {
    if (ispublic) {
      var res = await dispatch(validUserAction(ispublic))
      if (!res?.status) {
        navigate(RoutesPaths.ERROR_PAGE, { replace: true });
      }
    }
    if (ispublicCampain) {
      var res = await dispatch(getSingleCampaignDetailAction(ispublicCampain))
      if (!res?.status) {
        navigate(RoutesPaths.ERROR_PAGE, { replace: true });
      }
    }
  }

  useEffect(() => {
    if (!started) return;        // do nothing until start
    if (secondsLeft === 0) {     // timer expired
      doOtherAction();
      return;
    }

    const timerId = setInterval(() => {
      setSecondsLeft(sec => sec - 1);
    }, 1000);

    return () => clearInterval(timerId);
  }, [started, secondsLeft]);

  useEffect(() => {
    const initializePage = async () => {
      const urlToken = params.get("token");
      const uniqueId = params.get("uniqueId");
      if (uniqueId) {
        localStorage.setItem("token", uniqueId);
      }
      if (urlToken) {
        try {
          const response = await AuthService.exchangeChatEmailToken({ emailToken: urlToken });
          if (response?.data) {
            localStorage.setItem("token", response.data);
          }
        } catch (error) {
          console.error("Failed to exchange chat email token", error);
        }
      }

      trackActivationChatPageView(currentUserId);
      navigate(getPublicMessageDetailUrl(currentUserId), { replace: true });
      loadChatWithId();
    };

    initializePage();
  }, []);

  const findChatByParticipants = (chatList = [], userId1, userId2) => {
    return chatList.find(item => {
      const participantIds = item?.chat?.participants?.map(p => p.id);
      return (
        participantIds?.includes(userId1) &&
        participantIds?.includes(userId2)
      );
    });
  };

  const findChatById = (chatList = [], chatId) => {
    if (!chatId) return null;
    return chatList.find(item => item?.chat?._id === chatId) || null;
  };


  const loadChatWithId = async () => {
    setIsMessageLoading(true);
    let token = localStorage.getItem("token") || "";

    if (!token) {
      // 🔥 NO USER YET — decide UI here
      setHasExistingChat(false);

      if (ispublicCampain) {
        setMessages([
          createStaticMessage(
            "Please share your name and email so we can connect you with the campaign."
          )
        ]);
        setAskNameEmail(true);
        setStep("sendNameEmail");
        setInvestorDescribe(false);
        setIsObjective(false);
      } else {
        setMessages([
          createStaticMessage("👋 Hi there! Welcome to kimbocorp."),
          createStaticMessage("Before we proceed, can you tell us which of the following best describes you?")
        ]);
        setInvestorDescribe(true);
      }
      setIsMessageLoading(false);
      return;
    }

    try {
      // 1. Logged-in user
      const userResData = await dispatch(getProfileAction());
      const userResp = userResData?.data || {};
      const loggedInUserId = userResp?.id;

      // 2. Other user id (from URL)
      const otherUserId = ispublic;
      // or get it dynamically via useParams()

      // 3. Get all chats
      const chatRes = await dispatch(getAllChatList());
      const chatList = chatRes || [];

      // 4. Prefer the explicit room id from the URL, then fall back to participant matching
      const roomChat = findChatById(chatList, currentUserId);
      const matchedChat = roomChat || findChatByParticipants(
        chatList,
        loggedInUserId,
        otherUserId
      );

      if (matchedChat) {
        setHasExistingChat(true);   // ✅ USER EXISTS

        setAskNameEmail(false);
        setInvestorDescribe(false);
        setIsObjective(false);

        setSelected(matchedChat);

        const chatId = matchedChat.chat._id;
        if (chatId) {
          trackActivationChatPageView(chatId);
          navigate(getPublicMessageDetailUrl(chatId), { replace: true });
        }
        const s = io(process.env.REACT_APP_BACKEND_URL, {
          query: { userId: loggedInUserId },
        });

        setSocket(s);
        socketRef.current = s;
        s.emit("joinChat", chatId);
        const msgs = await getMessages(chatId);
        setMessages(msgs);
      } else {
        setHasExistingChat(false);  // ❌ NO USER
        console.log("ispublicCampain", ispublicCampain)
        if (ispublicCampain) {
          setMessages([
            createStaticMessage(
              "Please share your name and email so we can connect you with the campaign."
            )
          ]);
          setAskNameEmail(true);
          setStep("sendNameEmail");
        } else {
          setMessages([
            createStaticMessage("👋 Hi there! Welcome to kimbocorp."),
            createStaticMessage("Before we proceed, can you tell us which of the following best describes you?")
          ]);
          setInvestorDescribe(true);
        }

        // localStorage.removeItem("token");
      }
    } catch (error) {
      console.error(error);
      localStorage.removeItem("chatId");
    } finally {
      setIsMessageLoading(false);
    }
  };


  const createStaticMessage = (content, sender = null, module = null, data = null) => {
    const timestamp = Date.now();
    return {
      id: Date.now().toString(),
      sender,
      content,
      module: module,
      data: data,
      createdAt: timestamp,
      updatedAt: timestamp,
      __v: 0,
    };
  };

  const selRef = useRef(selected);
  useEffect(() => { selRef.current = selected; }, [selected]);

  useEffect(() => {
    if (!user?.id || !socket) return;

    const onNewMessage = msg => {
      if (msg?.sender) {
        if (msg?.sender?.id !== user?.id) {
          setAdvisorTimer(false);
          setStarted(false);
          setStep("");
        }
      }

      dispatch(updateChatLastMessage(msg.chat, msg));

      if (selRef.current?.chat._id === msg.chat) {
        setMessages(ms => [...ms, msg]);
      }
    };

    socket.on('newMessage', onNewMessage);
    loadChats();

    return () => {
      socket.off('newMessage', onNewMessage); // ✅ REMOVE LISTENER ONLY
    };
  }, [user, socket]);

  useEffect(() => {
    return () => {
      if (socketRef.current) {
        socketRef.current.disconnect();
        socketRef.current = null;
      }
    };
  }, []);

  const messagesRef = useRef(messages);
  useEffect(() => {
    messagesRef.current = messages;
  }, [messages, step]);

  useEffect(() => {
    if (ispublicCampain) {
      let trackingId = '';
      if (localStorage.getItem("trackingId")) {
        trackingId = localStorage.getItem("trackingId");
      }
      if (trackingId) {
        dispatch(getProfileByTrackingIdAction(trackingId))

      }
    }
  }, [ispublicCampain])

  useEffect(() => {
    let trackingId = '';
    if (localStorage.getItem("trackingId")) {
      trackingId = localStorage.getItem("trackingId");
    }
    if (trackingId) {
      setValue("name", publicProfile ? publicProfile?.first_name ? publicProfile?.first_name + " " + (publicProfile?.last_name ? publicProfile?.last_name : '') : publicProfile?.name : "")
      const email = publicProfile?.contactInfo?.email;
      setValue(
        "email",
        Array.isArray(email) ? email[0] || "" : email || ""
      );
    }
  }, [publicProfile, setValue])


  const sendToAPI = async (allData) => {
    var resp = await dispatch(addPublicUserAction(allData))
    if (resp?.chat) {
      navigate(getPublicMessageDetailUrl(resp.chat), { replace: true });
      var userResData = await dispatch(getProfileAction())
      var userResp = userResData?.data || {};
      if (userResp?.id) {
        const s = io(process.env.REACT_APP_BACKEND_URL, {
          query: { userId: userResp && userResp?.id }
        });
        setSocket(s);
        socketRef.current = s;
        if (!s || !resp.chat) return;
        const updatedMessages = messagesRef?.current?.map(msg => {
          if (msg.sender?.first_name === "user") {
            return {
              ...msg,
              sender: {
                first_name: allData.first_name,
                last_name: allData.last_name,
                id: userResp?.id,
              },
            };
          }
          return msg;
        });
        const data = await dispatch(getAllChatList());
        const filterData = data?.filter(x => x.chat?._id === resp?.chat)
        if (filterData?.length > 0) {
          setSelected(filterData[0])
        }
        setMessages(updatedMessages);
        s.emit('joinChat', resp?.chat);
        const existingMessages = await getMessages(resp?.chat);
        setMessages(existingMessages);
        // setEmailError(true)

        setHasExistingChat(true);      // ✅ NOW USER EXISTS
        setAskNameEmail(false);        // switch UI to input
        const hasAdvisorMessage = existingMessages.some(m =>
          m?.sender && m?.sender?.id && m?.sender?.id !== userResp?.id
        );

        if (!hasAdvisorMessage) {
          sendMessage(
            "⏳ Thanks! We're now connecting you with an advisor. This may take up to 120 seconds. Please stay on this page",
            resp?.chat,
            s,
            filterData?.length > 0 ? filterData[0] : [],
            "advisorConnect"
          );
        }
        return () => s.disconnect();
      }
      setEmailError(false);
    } else {
      setEmailError(true);
      setSubmitLoader(false)
      setMessages(prev => [...prev, createStaticMessage(resp?.data)]);
    }
  }

  const loadChats = async () => {
    const data = await dispatch(getAllChatList());
    const filterData = data?.filter(x => x.chat?._id === currentUserId)
    if (filterData?.length > 0) {
      setSelected(filterData[0])
    }
  };

  useEffect(() => {
    if (currentUserId) {
      dispatch(chatMediaGetAction(currentUserId));
    }
  }, [currentUserId, dispatch]);

  const onSubmit = async (data) => {
    setSubmitLoader(true)
    const fullName = data?.name.trim();
    const nameParts = fullName.split(" ").filter(part => part);
    const first_name = nameParts[0];
    const last_name = nameParts.length > 1 ? nameParts.slice(1).join(" ") : "";

    if (step === "sendNameEmail") {
      const newMsg = createStaticMessage(
        first_name,
        { first_name: "user", last_name: "", id: "" },
        PUSH_NOTIFICATION_MODULE.NAME_EMAIL,
        { first_name, last_name, email: data.email }
      );

      // 2) build the updated messages array yourself
      const updatedMessages = [...messages, newMsg];

      // 3) push into state
      setMessages(updatedMessages);
      let trackingId = '';
      if (localStorage.getItem("trackingId")) {
        trackingId = localStorage.getItem("trackingId");
      }

      let companyId = '';
      const storedCompanyId = localStorage.getItem("companyId");
      if (storedCompanyId && storedCompanyId !== "undefined") {
        companyId = storedCompanyId;
      }
      // 4) now send the payload—it will include newMsg
      const payload = {
        first_name: publicProfile ? publicProfile?.first_name : first_name,
        last_name: publicProfile ? publicProfile?.last_name ? publicProfile?.last_name : '' : last_name,
        email: data.email,
        messages: updatedMessages,
        userId: ispublic,
        campaignId: ispublicCampain,
        trackingId: trackingId ? trackingId : "",
        companyId: companyId ? companyId : ""
      };
      sendToAPI(payload);
      reset({ name: "", email: "" });
    }
  }

  const sendMessage = async (content, chatId, socketNew, chatData, stepProfile) => {
    if (!content.trim()) return;
    if (chatId) {
      if (socketNew && chatData) {
        const adminId = chatData?.chat?.admins[0]?.id;
        const adminInParticipants = chatData?.chat?.participants.find(p => p.id === adminId);
        if (stepProfile === "advisorConnect") {
          let payload = {
            senderId: null,
            message: content,
            module: PUSH_NOTIFICATION_MODULE.COUNTDOWN_MESSAGE,
            data: null
          }
          await sendMessagesServices(chatId, payload)
          setStep("NoAdvisorCome")
          setAdvisorTimer(true)
          setSecondsLeft(120);
          setStarted(true);
          setSubmitLoader(false)
        }
      };
    } else if (currentUserId) {
      if (socket && selected) {
        if (step === 'NoAdvisorCome') {
          setTimeout(() => {
            let payload = {
              senderId: null,
              message: "We are sorry as all our advisors are busy at the moment. We will reach out to you separately via email shortly. In the meantime, please type your ambitions or concerns so we can address them directly for you.",
              module: null,
              data: null
            }
            sendMessagesServices(currentUserId, payload)
            setStep("")
          }, 500);
        } else {
          socket.emit('sendMessage', {
            chatId: currentUserId,
            content
          });
        }

      };
    } else {
      setMessages(prev => [...prev, createStaticMessage(content, { first_name: "user", last_name: "", id: "", })]);
      if (step === 'askInvestor') {
        if (content === "Investor or fund manager") {
          setMessages(prev => [...prev, createStaticMessage("Great! As an investor or fund manager, we can help you set up tax-efficient fund structures, SPVs, or even Variable Capital Companies (VCCs).")]);
        } else if (content === "Consultant or advisor") {
          setMessages(prev => [...prev, createStaticMessage("Awesome! As a consultant or advisor, you might benefit from working with us to build your clients' holding structures. You could even join our advisor program.")]);
        } else if (content === "Startup founder or entrepreneur") {
          setMessages(prev => [...prev, createStaticMessage("Fantastic! As a startup founder or entrepreneur, we can help you formalize your venture with a holding company, open bank accounts, and connect you with customers and partners.")]);
        } else if (content === "Others") {
          setMessages(prev => [...prev, createStaticMessage("No problem! Whatever your commercial goals, we can support you. Let us know a bit more below.")]);
        }
        setInvestorDescribe(false)
        setMessages(prev => [...prev, createStaticMessage("👉 What’s the objective of your business?")]);
        setStep("confirmObjective")
        setIsObjective(true)
      } else if (step === 'confirmObjective') {
        if (content === "Others") {
          setStep("describeObjective")
          setMessages(prev => [...prev, createStaticMessage("Please describe")]);
          setIsObjective(false)
        } else {
          setIsObjective(false)
          setMessages(prev => [...prev, createStaticMessage("Lastly, can you share your name and email so we can connect you with a relevant advisor?")]);
          setAskNameEmail(true)
          setStep("sendNameEmail")
        }
      } else if (step === "describeObjective") {
        setMessages(prev => [...prev, createStaticMessage("Lastly, can you share your name and email so we can connect you with a relevant advisor?")]);
        setAskNameEmail(true)
        setStep("sendNameEmail")
      }
    }
  };


  const doOtherAction = () => {
    setAdvisorTimer(false)
    setStarted(false);
    setStep("NoAdvisorCome")
    sendMessage("It seems no advisor has joined yet. We've invited you to verify your email and sign into kimbocorp. Once you do, this conversation will continue from your dashboard.")
  };
  const closeImageViewer = () => {
    dispatch(chatMediaPreviewerAction(0, false));
  };
  const isActivationBusinessChat = !isMessageLoading && messages.some(message => message?.module === PUSH_NOTIFICATION_MODULE.ACTIVATE_BUSINESS);

  return (
    <>
      <div className={`container-fluid message-page ispublic-message-page`}>
        <div className="row messageRow">
          <div className="col-md-4 col-lg-3 messageLeft customScroll userListSidebar">
            <ChatSideBar isActivationBusinessChat={isActivationBusinessChat} />
          </div>
          <div
            className="col-md-8 col-lg-9 messageRight"
          >
            <ChatWindowStatic
              chat={selected?.chat}
              messages={messages}
              isMessageLoading={isMessageLoading}
              onSend={sendMessage}
              emailError={emailError}
              isObjective={isObjective}
              investorDescribe={investorDescribe}
              askNameEmail={askNameEmail}
              errors={errors}
              register={register}
              handleSubmit={handleSubmit}
              onSubmit={onSubmit}
              advisorTimer={advisorTimer}
              secondsLeft={secondsLeft}
              submitLoader={submitLoader}
              describeObjective={describeObjective}
              publicProfile={publicProfile}
              singleCampaignDetail={singleCampaignDetail}
              inviterDetails={inviterDetails}
            />
          </div>
        </div>
        {isViewerOpen && (
          <ImageViewer
            src={chatMediaFileName}
            currentIndex={currentImage}
            disableScroll={false}
            closeOnClickOutside={true}
            onClose={closeImageViewer}
            backgroundStyle={{ background: '#52594d', zIndex: 9999999999999 }}
          />
        )}
      </div>
    </>
  );
}
